import { getElement } from "../../utils";

const SELECTOR_COUNTDOWN = '.countdown';
const SELECTOR_NUMBERS = '.countdown-numbers';
const SELECTOR_DAYS = '.countdown-days';
const SELECTOR_HOURS = '.countdown-hours';
const SELECTOR_MINS = '.countdown-minutes';
const SELECTOR_SECS = '.countdown-seconds';

const ATTR_DATA_DATEEND = 'data-counter';
const ATTR_DATA_INTERVAL = 'data-interval';

const CLASS_NAME_SHOW = 'show';
const CLASS_NAME_INIT = 'countdown-init';
const CLASS_NAME_ENDED = 'ended';
class Countdown {
	constructor(element, config = {}) {
		this._config = config;

		this._element = getElement(element);

		this._dateEnd = config && config.dateEnd ? config.dateEnd : this._element.querySelector(SELECTOR_NUMBERS).getAttribute(ATTR_DATA_DATEEND) || 0;
		this._timeEnd = new Date(this._dateEnd).getTime();
		this._timeData = {
			second: 1000,
			minute: 1000 * 60,
			hour: 1000 * 60 * 60,
			day: 1000 * 60 * 60 * 24,
		};

		this._intervalId = this._element.getAttribute(ATTR_DATA_INTERVAL); //evita una doppia inizializzazione

		this._init();
	}

	//private

	_init() {
		this._element.classList.add(CLASS_NAME_INIT);
		this._setDate();
		if (this._intervalId) {
			clearInterval(this._intervalId);
		}
		this._intervalId = setInterval(() => this._setDate(), this._timeData.second);
		this._element.setAttribute(ATTR_DATA_INTERVAL, this._intervalId);
	}

	_setDate() {
		const distance = this._timeEnd - new Date().getTime();
		const elDays = this._element.querySelector(SELECTOR_DAYS);
		const elHours = this._element.querySelector(SELECTOR_HOURS);
		const elMins = this._element.querySelector(SELECTOR_MINS);
		const elSecs = this._element.querySelector(SELECTOR_SECS);

		if (distance > 0) {
			if (this._element.classList.contains(CLASS_NAME_ENDED)) {
				this._element.classList.remove(CLASS_NAME_ENDED);
			}
			elDays.innerText = Math.floor(distance / (this._timeData.day));
			elHours.innerText = Math.floor((distance % (this._timeData.day)) / (this._timeData.hour));
			elMins.innerText = Math.floor((distance % (this._timeData.hour)) / (this._timeData.minute));
			elSecs.innerText = Math.floor((distance % (this._timeData.minute)) / this._timeData.second);
		} else {
			//do something later when date is reached
			elDays.innerText = 0;
			elHours.innerText = 0;
			elMins.innerText = 0;
			elSecs.innerText = 0;

			this._element.classList.add(CLASS_NAME_ENDED);
			if (this._intervalId) {
				clearInterval(this._intervalId);
			}
		}
	}
}

window.Countdown = Countdown;

document.addEventListener("DOMContentLoaded", () => {
	const countdowners = document.querySelectorAll(SELECTOR_COUNTDOWN + ':not([' + ATTR_DATA_INTERVAL + '])');
	countdowners.forEach(el => new Countdown(el));
});

/*const countdownEl = document.querySelector('.countdown');
const countdownNumbers = document.querySelector('.countdown-numbers');
const dataEnd = countdownNumbers.getAttribute('data-counter');

if (countdownNumbers){
	const second = 1000,
	minute = second * 60,
	hour = minute * 60,
	day = hour * 24;

	let countDown = new Date(dataEnd).getTime(),
	countInterval = setInterval(function() {

		let now = new Date().getTime(),
			distance = countDown - now;

		if (distance > 0) {
			document.getElementById('days').innerText = Math.floor(distance / (day)),
			document.getElementById('hours').innerText = Math.floor((distance % (day)) / (hour)),
			document.getElementById('minutes').innerText = Math.floor((distance % (hour)) / (minute)),
			document.getElementById('seconds').innerText = Math.floor((distance % (minute)) / second);
		} else {
			//do something later when date is reached
			document.getElementById('days').innerText = 0,
			document.getElementById('hours').innerText = 0,
			document.getElementById('minutes').innerText = 0,
			document.getElementById('seconds').innerText = 0;

			countdownEl.classList.add('ended');
			clearInterval(countInterval);
		}

	}, second)

	setTimeout(()=>{
		countdownNumbers.classList.add('show');
	}, second);

}*/
